// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__163ui","name":"Header_name__2tDYV","birthday":"Header_birthday__2zFNG","skeleton":"Header_skeleton__isbu0"};